<script setup lang="ts">
import RatingStarGrayIcon from '@/assets/icons/RatingStarGrayIcon.vue';
import RatingStarYellowFilledIcon from '@/assets/icons/RatingStarYellowFilledIcon.vue';

defineProps<{
  isActive?: boolean;
  isDimmed?: boolean;
}>();
</script>

<template>
  <RatingStarYellowFilledIcon v-if="isActive" />
  <RatingStarYellowFilledIcon v-else-if="isDimmed" class="opacity-35 grayscale" />
  <RatingStarGrayIcon v-else />
</template>
